module.exports = __webpack_public_path__ + "static/media/0042_Medium.51b5ba4e.jpg";